const Real_estate = "Real estate"; //"Commercial real estate";
const real_estate = Real_estate.toLowerCase();
export default { Real_estate, real_estate };
